module.exports = __webpack_public_path__ + "img/2017-03-31.88266dc7.jpg";